import { render, staticRenderFns } from "./RecruitmentAdd.vue?vue&type=template&id=4e0f494a&scoped=true&"
import script from "./RecruitmentAdd.vue?vue&type=script&lang=js&"
export * from "./RecruitmentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f494a",
  null
  
)

export default component.exports